/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Srt_LabelInputs */

const en_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export SRT File(s)`)
};

const fr_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter le ou les fichiers SRT`)
};

const de_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT-Datei(en) exportieren`)
};

const it_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta file SRT`)
};

const ru_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт файла(ов) SRT`)
};

const es_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar archivo(s) SRT`)
};

const zh_cn2_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出 SRT 文件`)
};

const ja_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT ファイルをエクスポート`)
};

const hi_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT फ़ाइलें निर्यात करें`)
};

const pt_pt2_audio_description_export_srt_label = /** @type {(inputs: Audio_Description_Export_Srt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar arquivo(s) SRT`)
};

/**
* | output |
* | --- |
* | "Export SRT File(s)" |
*
* @param {Audio_Description_Export_Srt_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_srt_label = /** @type {((inputs?: Audio_Description_Export_Srt_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Srt_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_srt_label(inputs)
	if (locale === "de") return de_audio_description_export_srt_label(inputs)
	if (locale === "it") return it_audio_description_export_srt_label(inputs)
	if (locale === "ru") return ru_audio_description_export_srt_label(inputs)
	if (locale === "es") return es_audio_description_export_srt_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_srt_label(inputs)
	if (locale === "ja") return ja_audio_description_export_srt_label(inputs)
	if (locale === "hi") return hi_audio_description_export_srt_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_srt_label(inputs)
	return en_audio_description_export_srt_label(inputs)
});